import { eff } from "@/core/utils/effect-ts-abbr";
import { formatNumber } from "@/core/utils/format-number";
import { Prop, Vue } from "vue-property-decorator";

export class AppFormatNumberComponent extends Vue {
    @Prop({ required: true })
    value!: bigint | number;

    @Prop()
    options?: Intl.NumberFormatOptions;

    get formattedValue() {
        return eff.fn.pipe(this.value, formatNumber(this.options));
    }
}
